

const logger = require('../../logger/logger');
var stateManager = require('../../state/stateManager.js');
var stringUtil = require('../../string/stringUtil.js');

var WebSocketClient = require('../../webSocket/webSocketClient.js');
var paymentSenseRequestBuilder = require('./paymentSenseRequestBuilder.js');
var controlSettingsUtils = require('../../domain/settings/controlSettingsUtils');

module.exports.terminalId = null;
module.exports.url = null;
module.exports.webSocketClient = null;

var messageCallBackResponseTimeOut = 10000;
var closingWaitTime = 5000;
var messageCallBackTimer = null;
var messageCallBackReceived = false;

module.exports.connect = function(creditCardTerminalConfiguration, onConnect, onConnectionError)
{
    var self = this;
    module.exports.terminalId = null;
    
    try
    {
        if (stringUtil.isStringNullOrEmpty(creditCardTerminalConfiguration.terminalId))
            throw "Failed to find card terminal id";

        if (stringUtil.isStringNullOrEmpty(creditCardTerminalConfiguration.url))
            throw "Failed to find card terminal address";

        if (stringUtil.isStringNullOrEmpty(creditCardTerminalConfiguration.apiKey))
            throw "Failed to find card terminal key";

        var url = creditCardTerminalConfiguration.url;
        var apiKey = creditCardTerminalConfiguration.apiKey;
        this.terminalId = creditCardTerminalConfiguration.terminalId;
        
        this.url = `wss://${url}/pac?token=${apiKey}&api-version=v0`
        this.webSocketClient = new WebSocketClient(this.url);
        
        this.webSocketClient.onOpenCallBack = () => 
        {
            var request = paymentSenseRequestBuilder.buildRequest("connectedTerminals");
            request.params["status"] = "AVAILABLE";
            request.params["currency"] = "GBP";

            self.webSocketClient.onOpenCallBack = null;
            self.sendRequest(request);
        };

        this.webSocketClient.onErrorCallBack  = (e) =>
        {
            self.close();
            onConnectionError(e);
        };

        this.webSocketClient.onMessageCallBack = (response) =>
        {
            if (response == null || response.result == null || !response.result.length || response.result.length <= 0)
            {
                self.close();
                onConnectionError("Failed to load connected terminals.");
                return;
            }
            
            var givenTerminalFound = false;
            var connectedTerminalIds = "";
            for (var index = 0; index < response.result.length; index++)
            {
                var connectedTerminal = response.result[index];
                var tpi = connectedTerminal.tpi;

                if (connectedTerminalIds == "")
                    connectedTerminalIds = tpi;
                else
                    connectedTerminalIds = connectedTerminalIds + "," + tpi;

                if (tpi == this.terminalId)
                    givenTerminalFound = true;
            }
            if (!givenTerminalFound)
            {
                self.close();
                onConnectionError(`Terminal Id '${creditCardTerminalConfiguration.terminalId}' not found in payment sense`);
                return; 
            }

            self.webSocketClient.onMessageCallBack = null;
            onConnect();
        }

        this.webSocketClient.connect();

    }
    catch(error)
    {
        self.close();
        onConnectionError(error);
    }
}


module.exports.chargeAmount = (saleId, amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline) =>
{
    this.startTransactionWithAttempt(amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline, 'sale', 1);
}

module.exports.refundAmount = (amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline) =>
{
    this.startTransactionWithAttempt(amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline, 'refund', 1);
}

module.exports.startTransactionWithAttempt = (amount, 
                                              onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline, 
                                              transactionType, attemptNumber) =>
{

    /*
        There are times when websocket client is disconnected and we never get any notification. 
        To solve this issue, I am setting a timer and assuming that within 10 sec, if I dont get any message or error call back I am disconncted and will reconnect.
    */

    messageCallBackReceived = false;
    messageCallBackTimer = setTimeout(()=>
    {

        if (messageCallBackReceived)
            return;

        clearTimeout();

        if (this.webSocketClient.isSocketConnected())
            onError(`It seems like system/PDQ is not connected to internet. Please make sure PDQ is connected to internet and try again in 10 seconds.`);
        else
        {
            onStatusMessage("Reconnecting to Server");
            this.disconnectAndReConnectWebSocket()
            .then(()=>
            {
                onStatusMessage("Please wait");
                this.startTransaction(amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline, transactionType);
            }, (error) =>
            {
                onError(error)
            });
        }

        
    }, messageCallBackResponseTimeOut);

    this.startTransaction(amount, 
    (statusMessage)=>
    {
        this.clearMessageCallBackTimeOut();
        onStatusMessage(statusMessage);
    }, 

    (errorMessage)=>
    {
        this.clearMessageCallBackTimeOut();
        onError(errorMessage);
    },

    (responseId, receiptLines)=>
    {
        this.clearMessageCallBackTimeOut();
        onSignatureVerification(responseId, receiptLines)
    },

    ()=>
    {
        this.clearMessageCallBackTimeOut();
        onSignatureVerificationTimeout()
    },

    (result)=>
    {
        this.clearMessageCallBackTimeOut();
        onSuccessful(result);
    },

    ()=>
    {
        this.clearMessageCallBackTimeOut();
        onDecline()
    },
    transactionType, attemptNumber);
}

module.exports.clearMessageCallBackTimeOut = () =>
{
    try
    {
        messageCallBackReceived = true;

        if (messageCallBackTimer != null)
            clearTimeout(messageCallBackTimer);

        messageCallBackTimer = null;
    }
    catch(error)
    {
        logger.error("Error occurred while clearing the message callback timer", {}, error);
    }
}

module.exports.sleep = (milliSeconds) =>
{
    return new Promise(resolve => setTimeout(resolve, milliSeconds));
}

module.exports.disconnectAndReConnectWebSocket = ()=>
{
    return new Promise((resolve, reject) =>
    {
        this.webSocketClient.close();
        this.sleep(closingWaitTime)
        .then(()=>
        {
            this.webSocketClient.onOpenCallBack = () => 
                                                    {
                                                        resolve("DONE");
                                                    };

            this.webSocketClient.onErrorCallBack  = (e) =>
                                                        {
                                                            reject(e);
                                                        };

            this.webSocketClient.connect();
        })
    });
}

module.exports.startTransaction = (amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline, transactionType) =>
{
    var request = paymentSenseRequestBuilder.buildRequest(transactionType);
    request.params["tpi"] = this.terminalId;
    request.params["currency"] = "GBP";
    request.params["amount"] = (amount * 100).toFixed(0) * 1;

    this.webSocketClient.onMessageCallBack = (response) =>
    {
        if (response.error != null)
        {
            if (response.error.code == "-32074")
            {
                onSignatureVerificationTimeout();
                return;
            }

            var errorMessage = "Error occurred while processing payment.";
            if (response.error.data != null && response.error.data.userMessage != null)
                errorMessage = "Error Message: '" + response.error.data.userMessage + "', Error Code: '" + response.error.code + "'";

            this.webSocketClient.onMessageCallBack = null;
            onError(errorMessage);
            return;
        }

        if (response.method != null && response.method.toUpperCase() == "terminalNotification".toUpperCase())
        {
            var notificationMessage = response.params.notificationValue;
            notificationMessage = stringUtil.replaceAll(notificationMessage, "_", " ");
            notificationMessage = stringUtil.toHumanize(notificationMessage);
        
            onStatusMessage(notificationMessage);
            return;
        } 
        
        if (response.method != null && response.method.toUpperCase() == "signatureVerificationRequest".toUpperCase())
        {
            if (!controlSettingsUtils.getSignatureCardAllowed())
            {
                this.verifyCardSignature(response.id, false);
                return;
            }

            var receiptLines = response.params.receiptLines.MERCHANT;
            onSignatureVerification(response.id, receiptLines);
            return;
        } 

        this.webSocketClient.onMessageCallBack = null;
        var result = response.result;
        if (result.transactionResult != null && result.transactionResult.toUpperCase() == "SUCCESSFUL")
        {
            result.driver = "PaymentSense";
            onSuccessful(result);
            return;
        }

        if (result.transactionResult != null && result.transactionResult.toUpperCase() == "TIMED_OUT")
        {
            onError("Communication with the PDQ has failed");
            return;
        }

        onDecline();
    }
    this.sendRequest(request);
}

module.exports.verifyCardSignature = (requestId, verified)=>
{
    var response = paymentSenseRequestBuilder.buildResponse(requestId);
    response.result.accepted = verified;
    this.sendRequest(response);
}



module.exports.sendRequest = function(request)
{
    this.webSocketClient.sendMessage(JSON.stringify(request));
}


module.exports.close = function()
{
    if (this.isConnected())
    {
        this.webSocketClient.close();
    }

    this.terminalId = null;
    this.url = null;
    this.webSocketClient = null;

    var creditCardCardTerminal = stateManager.getStore().getState().creditCardTerminal;
    creditCardCardTerminal.isConnected = false;
}

module.exports.isConnected = function()
{
    return this.webSocketClient != null && this.webSocketClient.isSocketConnected();
}
